import { replaceNode } from '../utils'

export default class RemoteSearchForm extends HTMLElement {
  connectedCallback() {
    if (!this.form) return
    if (!this.submitHandler) this.submitHandler = this.submit.bind(this)
    this.form.addEventListener('submit', this.submitHandler)
    if (this.formData.get('q').length > 0) {
      this.performSearch()
    }
  }

  disconnectedCallback() {
    if (this.form && this.submitHandler) {
      this.form.removeEventListener('submit', this.submitHandler)
    }
  }

  async submit(event) {
    event.preventDefault()
    this.pushHistoryState()
    await this.performSearch()
  }

  async performSearch() {
    this.toggleLoadingAnimation()
    const response = await fetch(this.searchUrl, {
      method: 'get',
      credentials: 'omit',
      mode: 'cors',
      headers: new Headers({
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'text/html; fragment=true'
      })
    })
    const content = await response.text()
    this.transclude(content)
  }

  pushHistoryState() {
    const location = new URL(this.queryString, window.location.href)
    if (window.Turbo?.navigator?.history) {
      window.Turbo.navigator.history.push(location)
    } else {
      window.history.pushState(null, '', location.href)
    }
  }

  transclude(content) {
    const dom = document.createElement('div')
    dom.innerHTML = content
    if (dom.firstElementChild.children.length === 0) {
      dom.firstElementChild.innerHTML = this.nothingFoundMessage()
    }

    replaceNode(
      this.resultTarget,
      ...dom.querySelectorAll(this.resultSourceSelector)
    )
    this.toggleLoadingAnimation()
  }

  nothingFoundMessage() {
    const message =
      this.formData.get('l') === 'de'
        ? 'Leider nichts gefunden.'
        : 'Sorry, nothing found.'
    return `<h1>🙈</h1><h2>${message}</h2>`
  }

  toggleLoadingAnimation() {
    if (this.button.hasAttribute('disabled')) {
      this.button.removeAttribute('disabled')
      this.resultTarget.classList.remove('is-hidden')
      this.loadingAnimation.classList.add('is-hidden')
    } else {
      this.button.setAttribute('disabled', 'disabled')
      this.resultTarget.classList.add('is-hidden')
      this.loadingAnimation.classList.remove('is-hidden')
    }
  }

  get form() {
    return this.querySelector('form')
  }

  get searchUrl() {
    return `${this.form.getAttribute('action')}${this.queryString}`
  }

  get queryString() {
    return `?q=${encodeURI(this.formData.get('q'))}&l=${this.formData.get('l')}`
  }

  get formData() {
    return new FormData(this.form)
  }

  get resultTarget() {
    const targetSelector = this.getAttribute('result-target')
    return document.querySelector(targetSelector)
  }

  get resultSourceSelector() {
    return this.getAttribute('result-source')
  }

  get loadingAnimation() {
    const loadingAnimationSelector = this.getAttribute('loading-selector')
    return document.querySelector(loadingAnimationSelector)
  }

  get button() {
    return (
      this.querySelector('button[type=submit]') ||
      this.querySelector('input[type=submit]')
    )
  }
}
